import type {
  AEvent,
  EventTransformerHooks,
  EventName,
  UseTransformEvent,
  ExtractSourceEvent,
  ExtractTargetEvent,
} from "./createUseEmitRawEvent";

export function mergeEventTransformerHooks<
  TSourceEvent extends AEvent,
  TTargetEvent extends AEvent,
  T extends Readonly<EventTransformerHooks<TSourceEvent, TTargetEvent>>[]
>(
  ...allTransformerHooks: T
): EventTransformerHooks<
  ExtractSourceEvent<T[number]>,
  ExtractTargetEvent<T[number]>
> {
  const eventNameToTransformMap: EventTransformerHooks<
    TSourceEvent,
    TTargetEvent
  > = {};

  for (const singleTransformerHooks of allTransformerHooks) {
    for (const [eventName, currentTransformerHooks] of Object.entries(
      singleTransformerHooks
    ) as [
      EventName<TSourceEvent>,
      UseTransformEvent<TSourceEvent, TTargetEvent>[]
    ][]) {
      const prevTransformerHooks = eventNameToTransformMap[eventName];
      if (prevTransformerHooks === undefined) {
        eventNameToTransformMap[eventName] = [...currentTransformerHooks];
        continue;
      }

      eventNameToTransformMap[eventName] = [
        ...prevTransformerHooks,
        ...currentTransformerHooks,
      ];
    }
  }

  return Object.freeze(
    eventNameToTransformMap as unknown as EventTransformerHooks<
      ExtractSourceEvent<T[number]>,
      ExtractTargetEvent<T[number]>
    >
  );
}
